import React, { useEffect, useState } from 'react';

function ToggleButtons({ name1, name2, onToggle }) {
  const [activeButton, setActiveButton] = useState(name1);

  const handleClick = (name) => {
    setActiveButton(name);
    onToggle(name); // Trigger the callback with the new active button's name
  };

  useEffect(() => {
    onToggle(name1);
  }, []);

  return (
    <div className="flex w-full rounded-2xl bg-[#EDF1F5] p-1.5">
      {[name1, name2].map((name) => {
        const isActive = activeButton === name;
        return (
          <button
            key={name}
            type="button" // Prevents accidental form submissions
            onClick={() => handleClick(name)}
            className={`min-h-[42px] flex-1 rounded-xl px-2 py-2 text-[13px] font-bold transition-all duration-200 ${
              isActive
                ? 'bg-white text-primary shadow-[0_3px_10px_rgba(20,35,58,0.10)]'
                : 'text-muted hover:text-primary'
            }`}
          >
            {name}
          </button>
        );
      })}
    </div>
  );
}

export default ToggleButtons;
